import Header from "../Header";
import React, {useEffect} from "react";
import ReactGA from "react-ga";
import {Link} from "react-router-dom";

const FormSubmitted = () => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + "/formSubmitted");
    }, []);
    return (<>
        <Header title="Aitäh"/>
        <progress className="progress is-link" value={1} max={1}/>
        <section className="section">
            <div className="container">
                <h1 className="subtitle">
                    Ongi kõik! Aitäh kaasa mõtlemast ja edu algaval semestril!
                </h1>

                <p className="text">
                    Kui Sul on huvi programmeerimisega rohkem tutvust teha, siis:
                    <ul>
                        <li><a href="https://pydoc.pages.taltech.ee/"
                               target="_blank">https://pydoc.pages.taltech.ee/</a> - siit leiad õppematerjalid;
                        </li>
                        <li><a href="https://moodle.taltech.ee/course/view.php?id=32806" target="_blank">Täienduskursus Moodle keskkonas</a> - siit
                            leiad harjutamiskeskkonna.
                        </li>
                    </ul>
                </p>
                <p className="text">
                    Kui peaks veel vaja minema, siis <a href="https://discord.gg/3pg2sNUStB" target="_blank">Discordi
                    link on siin</a>.
                </p>
                <p className="text">
                    Lisaks võid leida kokkuvõtte kõigis sammudes nähtud infost <Link to="/info">siin</Link>.
                </p>
                <p className="text">
                    Kõik onboardingus kasutatud videod on näha siin: <a href="https://www.youtube.com/watch?v=HXfmANk_16Y&list=PLPszdKAlKCXU5lvIzmyasc8X1-pQZXpNv&ab_channel=TalTechCoding" target="_blank">Onboarding playlist</a>
                </p>
            </div>
        </section>
    </>);
};

export default FormSubmitted;
